import React, { useEffect, useState } from 'react'
import { Box, Select, FormControl, Stack, Input, Text } from '@/components/lib'
import utils from '../../utils/utils'
import useStore from '../../store'

export default function HeightEditor ({ value, onChange }) {
  const { settings, changeSetting } = useStore()
  const measurement = settings?.heightMeasureType || 'metric'
  const [height, setHeight] = useState()
  const [heightFeet, setHeightFeet] = useState()
  const [heightInches, setHeightInches] = useState()

  useEffect(() => {
    const val = value?.toString() || ''
    setHeight(val)
    const imperial = utils.cmToFeet(val || 0)
    if (imperial) {
      setHeightFeet(imperial.feet)
      setHeightInches(imperial.inches)
    }
  }, [value])

  const updateMetricHeight = cm => {
    if (cm === '' || parseFloat(cm) >= 0) {
      setHeight(cm)
      onChange(cm)
    }
    const imperial = utils.cmToFeet(cm || 0)
    if (imperial) {
      setHeightFeet(imperial.feet)
      setHeightInches(imperial.inches)
    }
  }

  const updateImperialHeight = (feet, inches) => {
    setHeightFeet(feet)
    if (inches === '' || (parseFloat(inches) >= 0 && parseFloat(inches) < 12)) {
      setHeightInches(inches)
    }
    if (!feet && !inches) {
      setHeight('')
      onChange('')
    } else if (feet || inches) {
      const cm = utils.feetToCm(feet || 0, inches || 0)
      setHeight(cm)
      onChange(cm)
    }
  }

  return (
    <Box>
      <Box>
        <Select
          w='200px' placeholder='Measurement type...' size='xs' mr={2} bg='bg.surface'
          value={measurement}
          onChange={e => changeSetting('heightMeasureType', e.target.value || 'metric')}
        >
          <option value='metric'>Metric (cm)</option>
          <option value='imperial'>Imperial (ft & inches)</option>
        </Select>
      </Box>

      <Box display={{ md: 'flex' }} mt={2}>
        {measurement === 'metric' &&
          <>
            <FormControl bg='bg.accent' rounded='md' p={2} w='150px' label='Height'>
              <Stack direction='row' alignItems='center'>
                <Input width='80px' bg='bg.surface' size='sm' value={height ?? ''} onChange={e => updateMetricHeight(e.target.value.replace(/[^\d.]/g, ''))} />
                <Text>cm</Text>
              </Stack>
            </FormControl>
          </>}

        {measurement === 'imperial' &&
          <>
            <FormControl bg='bg.accent' rounded='md' p={2} w='270px' label='Height'>
              <Stack direction='row' spacing={10}>
                <Stack direction='row' alignItems='center'>
                  <Input width='60px' bg='bg.surface' size='sm' value={heightFeet ?? ''} onChange={e => updateImperialHeight(e.target.value.replace(/[^\d.]/g, ''), heightInches)} />
                  <Text>feet</Text>
                </Stack>
                <Stack direction='row' alignItems='center'>
                  <Input width='60px' bg='bg.surface' size='sm' value={heightInches ?? ''} onChange={e => updateImperialHeight(heightFeet, e.target.value.replace(/[^\d.]/g, ''))} />
                  <Text>inches</Text>
                </Stack>
              </Stack>
            </FormControl>
          </>}
      </Box>
    </Box>
  )
}
